import { Stack } from '@mui/material';

import { Button } from '@/components/form/baseInputs/Button';
import { MinusIcon } from '@/components/icons/MinusIcon';
import { PlusIcon } from '@/components/icons/PlusIcon';

const ICON_SIZE = 16;

interface BulkSizeControlsProps {
  onIncrease: () => void;
  onDecrease: () => void;
  canIncrease: boolean;
  canDecrease: boolean;
}

/**
 * Increase/decrease tile size controls. Mirrors the icon-shape picker trigger
 * styling (transparent xs button, 16px icon, 4px padding, no border) but
 * without the popover — the buttons act directly on click.
 */
export function BulkSizeControls({
  onIncrease,
  onDecrease,
  canIncrease,
  canDecrease,
}: BulkSizeControlsProps) {
  return (
    <Stack direction="row" spacing={0}>
      <Button
        onClick={onIncrease}
        disabled={!canIncrease}
        size="xs"
        variant="transparent"
        square
        aria-label="Increase tile size"
      >
        <PlusIcon size={ICON_SIZE} />
      </Button>
      <Button
        onClick={onDecrease}
        disabled={!canDecrease}
        size="xs"
        variant="transparent"
        square
        aria-label="Decrease tile size"
      >
        <MinusIcon size={ICON_SIZE} />
      </Button>
    </Stack>
  );
}
